import { nanoid } from "@reduxjs/toolkit";
import shoes1 from "../../../assets/women/sneakers/shoes1.png";
import shoes11 from "../../../assets/women/sneakers/shoes11.png";
import shoes12 from "../../../assets/women/sneakers/shoes12.png";
import shoes13 from "../../../assets/women/sneakers/shoes13.png";

import shoes2 from "../../../assets/women/sneakers/shoes2.png";
import shoes21 from "../../../assets/women/sneakers/shoes21.png";
import shoes22 from "../../../assets/women/sneakers/shoes22.png";
import shoes23 from "../../../assets/women/sneakers/shoes23.png";

import shoes3 from "../../../assets/women/sneakers/shoes3.png";
import shoes31 from "../../../assets/women/sneakers/shoes31.png";
import shoes32 from "../../../assets/women/sneakers/shoes32.png";
import shoes33 from "../../../assets/women/sneakers/shoes33.png";

import shoes4 from "../../../assets/women/sneakers/shoes4.png";
import shoes41 from "../../../assets/women/sneakers/shoes41.png";
import shoes42 from "../../../assets/women/sneakers/shoes42.png";
import shoes43 from "../../../assets/women/sneakers/shoes43.png";

import shoes5 from "../../../assets/women/sneakers/shoes5.png";
import shoes51 from "../../../assets/women/sneakers/shoes51.png";
import shoes52 from "../../../assets/women/sneakers/shoes52.png";
import shoes53 from "../../../assets/women/sneakers/shoes53.png";

import shoes6 from "../../../assets/women/sneakers/shoes6.png";
import shoes61 from "../../../assets/women/sneakers/shoes61.png";
import shoes62 from "../../../assets/women/sneakers/shoes62.png";
import shoes63 from "../../../assets/women/sneakers/shoes63.png";

import shoes7 from "../../../assets/women/sneakers/shoes7.png";
import shoes71 from "../../../assets/women/sneakers/shoes71.png";
import shoes72 from "../../../assets/women/sneakers/shoes72.png";
import shoes73 from "../../../assets/women/sneakers/shoes73.png";

import shoes8 from "../../../assets/women/sneakers/shoes8.png";
import shoes81 from "../../../assets/women/sneakers/shoes81.png";
import shoes82 from "../../../assets/women/sneakers/shoes82.png";
import shoes83 from "../../../assets/women/sneakers/shoes83.png";

import shoes9 from "../../../assets/women/sneakers/shoes9.png";
import shoes91 from "../../../assets/women/sneakers/shoes91.png";
import shoes92 from "../../../assets/women/sneakers/shoes92.png";
import shoes93 from "../../../assets/women/sneakers/shoes93.png";

export const SneakersWomenData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "Mayze Beach Days Women's Sneakers",
    price: 3999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Frosty Pink",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The Mayze Beach Days sneaker is ready for the hottest season of the year. Admit it: the unique translucent outsole caught your eye",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "The Mayze Beach Days sneaker is ready for the hottest season of the year. Admit it: the unique translucent outsole caught your eye. Imagine what it would be like walking around in them. A crisp white upper to keep the heat at bay, and light colourful touches so you can be spotted in any crowd. It's the new addition to your collection you didn't know you needed.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Platform",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0.0 mm",
      },
      {
        id: nanoid(),
        point: "Synthetic upper",
      },
      {
        id: nanoid(),
        point: "Synthetic Formstrip and heel cap",
      },
      {
        id: nanoid(),
        point:
          "Debossed and screen printed PUMA branding on heel, quarter and tongue label",
      },
      {
        id: nanoid(),
        point: "Platform silhouette",
      },
      {
        id: nanoid(),
        point: "Rubber midsole",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "Mayze Beach Days Women's Sneakers",
    price: 3999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Spring Fern",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The Mayze Beach Days sneaker is ready for the hottest season of the year. Admit it: the unique translucent outsole caught your eye",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "The Mayze Beach Days sneaker is ready for the hottest season of the year. Admit it: the unique translucent outsole caught your eye. Imagine what it would be like walking around in them. A crisp white upper to keep the heat at bay, and light colourful touches so you can be spotted in any crowd. It's the new addition to your collection you didn't know you needed.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Platform",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0.0 mm",
      },
      {
        id: nanoid(),
        point: "Synthetic upper",
      },
      {
        id: nanoid(),
        point: "Synthetic Formstrip and heel cap",
      },
      {
        id: nanoid(),
        point:
          "Debossed and screen printed PUMA branding on heel, quarter and tongue label",
      },
      {
        id: nanoid(),
        point: "Platform silhouette",
      },
      {
        id: nanoid(),
        point: "Rubber midsole",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes2,
      },
      {
        id: nanoid(),
        imgCard: shoes21,
      },
      {
        id: nanoid(),
        imgCard: shoes22,
      },
      {
        id: nanoid(),
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "Slipstream 'Evolution Of The Classics' Women's Sneakers",
    price: 4949,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "white in 1987, the OG PUMA Slipstream Lo entered the scene as a basketball sneaker. A high-flying, slam-dunking, statement",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Back in 1987, the OG PUMA Slipstream Lo entered the scene as a basketball sneaker. A high-flying, slam-dunking, statement-making basketball sneaker. Now, it’s joined by Slipstream – a rework of the original that brings an all-new energy to the game while staying true to the OG’s sporting roots. This version is outfitted with a leather upper and tumbled leather overlays, as well as a metal lace jewel",

    detail: [
      {
        id: nanoid(),
        point: "Leather base",
      },
      {
        id: nanoid(),
        point: "Tumbled leather vamp and quarter panel overlay",
      },
      {
        id: nanoid(),
        point: "Synthetic eyestay, Formstrip, cut-out window and heel overlay",
      },
      {
        id: nanoid(),
        point: "Embossed leather detail on bottom eyestay",
      },
      {
        id: nanoid(),
        point: "Metal lace jewel with mini Formstrip",
      },
      {
        id: nanoid(),
        point: "Rubber midsole",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Yongzhou Yuanway Sports Shoes Co Ltd",
      },

      {
        id: nanoid(),
        point:
          "FCNDT HUNAN PROVINCE New Industrial Park Block six Ningyuan County 425600 YONGZHOU CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes31,
      },
      {
        id: nanoid(),
        imgCard: shoes32,
      },
      {
        id: nanoid(),
        imgCard: shoes33,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "Mayze Stack XPL Infuse Women's Sneakers",
    price: 5499,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Sedate Gray",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Infuse is back. This line of elevated essentials for women is updated for a new season, with an approach that stands out with",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Infuse is back. This line of elevated essentials for women is updated for a new season, with an approach that stands out with bold purples and greens. This version of the Mayze Stack takes on a leather upper with a nubuck Formstrip and eyestay, as well as a suede back quarter panel",

    detail: [
      {
        id: nanoid(),
        point: "Leather vamp and quarter",
      },
      {
        id: nanoid(),
        point: "Nubuck Formstrip, eyestay and heel cap",
      },
      {
        id: nanoid(),
        point: "Suede back quarter panel overlay",
      },
      {
        id: nanoid(),
        point: "Textile tongue and collar",
      },
      {
        id: nanoid(),
        point: "Rubber midsole",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
      {
        id: nanoid(),
        point: "Platform silhouette",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes4,
      },
      {
        id: nanoid(),
        imgCard: shoes41,
      },
      {
        id: nanoid(),
        imgCard: shoes42,
      },
      {
        id: nanoid(),
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "PUMA Propella Women's Sneakers",
    price: 2799,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Sedate Gray-Green Fog-PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Step into the spotlight with the PUMA Propella Women's Sneakers. Designed as a low boot with a lacing system, these",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Step into the spotlight with the PUMA Propella Women's Sneakers. Designed as a low boot with a lacing system, these sneakers inherit the Carina DNA and features a low to the ground tooling and a sleeker upper for a clean court silhouette encapsulating the essence of sneakerhead culture. With their understated yet timeless design, they’re the go-to choice for those who appreciate subtlety and class in their kicks",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Synthetic upper",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on lateral side",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "TATA",
      },

      {
        id: nanoid(),
        point:
          "IN Tamilnadu No. 95/1 Poondi Road Vaniyan Chathiram, Sumaithangi Post, Kaveripakkam s632508 Ranipet",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes5,
      },
      {
        id: nanoid(),
        imgCard: shoes51,
      },
      {
        id: nanoid(),
        imgCard: shoes52,
      },
      {
        id: nanoid(),
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "Rider Future Vintage Unisex Sneakers",
    price: 4769,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Rickie Orange",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Step into a time capsule of style with the Rider Future Vintage Unisex Sneakers. A bold confluence of past and present, these",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Step into a time capsule of style with the Rider Future Vintage Unisex Sneakers. A bold confluence of past and present, these sneakers boast a vibrant colorblock design that merges harmoniously with futuristic details, creating a sneaker that doesn't just follow trends but sets them. And it's not just about looks - with a durable outsole, every step is a grounded experience, resonating well with every sneakerhead who appreciates the old-school charm with modern style.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 14 mm",
      },
      {
        id: nanoid(),
        point: "Ripstop nylon upper",
      },
      {
        id: nanoid(),
        point: "Suede toe, heel and eyestay overlays",
      },
      {
        id: nanoid(),
        point: "Nylon tongue with woven label",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip with nylon piping",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Putian Baiho Footwear Co.LTD.",
      },

      {
        id: nanoid(),
        point:
          "FCNXB Fujian No.1518, GUCHENG EAST ROAD, HU ANGSHI TOWN, LICHENG DISTRICT, 351144 Putian",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes6,
      },
      {
        id: nanoid(),
        imgCard: shoes61,
      },
      {
        id: nanoid(),
        imgCard: shoes62,
      },
      {
        id: nanoid(),
        imgCard: shoes63,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes7,
    title: "Electron E Unisex Sneakers",
    price: 2749,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-CASTLEROCK",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "There's more to the Electron E Trainers than meets the eye. Its visible technology highlights fantastic features like a breathable",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "There's more to the Electron E Trainers than meets the eye. Its visible technology highlights fantastic features like a breathable mesh upper, synthetic quarter panels for support and a bold aesthetic that's both fun and futuristic. The elastic band on the heel provides extra comfort",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Breathable mesh upper",
      },
      {
        id: nanoid(),
        point: "Synthetic quarter panels for support",
      },
      {
        id: nanoid(),
        point: "Elastic band on heel for extra comfort",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo at lateral toe",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark across heel",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Vietnam Kim Viet Footwear Co.LTD",
      },

      {
        id: nanoid(),
        point:
          "FVNKM Nong Cong Industial Clusters Nong Cong Town, Nong Cong County 453800 Thanh Hoa",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes7,
      },
      {
        id: nanoid(),
        imgCard: shoes71,
      },
      {
        id: nanoid(),
        imgCard: shoes72,
      },
      {
        id: nanoid(),
        imgCard: shoes73,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes8,
    title: "Game Women's Sneakers",
    price: 2759,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Peach Parfait-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Ace your game and the day with the Game Women's Shoes, a perfect balance of PUMA's bold branding, quality and features like",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Ace your game and the day with the Game Women's Shoes, a perfect balance of PUMA's bold branding, quality and features like the EVA midsole that offers optimal cushioning and grip.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Mesh upper for breathability",
      },
      {
        id: nanoid(),
        point: "Breathable mesh upper",
      },
      {
        id: nanoid(),
        point: "EVA midsole for cushioning and traction",
      },
      {
        id: nanoid(),
        point: "PUMA branding",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SSIPL RETAIL LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN SIRMOUR VILL-MEHRUWALA,PO-BHAGANI TEHSIL-PAONTASAHIB DISTT-SIRMO HP 173025 PAONTASAHIB",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes8,
      },
      {
        id: nanoid(),
        imgCard: shoes81,
      },
      {
        id: nanoid(),
        imgCard: shoes82,
      },
      {
        id: nanoid(),
        imgCard: shoes83,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes9,
    title: "Daze V2 Unisex Sneakers",
    price: 1999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Granola-Dusty Tan-Pristine",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Elevate, intensify the Style drills, out run those goals, here are the perfect PUMA Shoes an all season favorite , perfect for leisure",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Elevate, intensify the Style drills, out run those goals, here are the perfect PUMA Shoes an all season favorite , perfect for leisure.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Synthetic & Mesh Upper provides breathability & durabilty",
      },
      {
        id: nanoid(),
        point: "low boot construction with lace closure",
      },
      {
        id: nanoid(),
        point: "PUMA Logo for subtle branding",
      },
      {
        id: nanoid(),
        point: "Rubber Outsole for traction",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT LAL TAPPER INDUSTRIAL AREA NH-72 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes9,
      },
      {
        id: nanoid(),
        imgCard: shoes91,
      },
      {
        id: nanoid(),
        imgCard: shoes92,
      },
      {
        id: nanoid(),
        imgCard: shoes93,
      },
    ],
  },
];
